export default __webpack_public_path__ + "static/media/AttachfileW.efbb38d6.svg";